import { DropdownItem, DropdownOptionType } from '@ardoq/dropdown-menu';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { Box, FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { colors } from '@ardoq/design-tokens';
import { t, type I18nLocale } from '@ardoq/i18n';

export const scenarioIsolationHelperText = (
  i18nLocale: I18nLocale
): DropdownItem => ({
  type: DropdownOptionType.CUSTOM_CONTENT_OPTION,
  content: (
    <Box padding="small" maxWidth="370px" key="scenario-isolation-helper-text">
      <FlexBox flexDirection="row" flexWrap={false} gap="xsmall" align="start">
        <Icon
          iconName={IconName.INFO}
          iconSize={IconSize.SMALL}
          color={colors.textSubtle}
        />
        <Text variant="caption" color="textSubtle">
          {t(
            i18nLocale,
            'appContainer:navigatorTopBar.scenarioIsolationHelperText',
            'Changes you make in a scenario stay isolated from the mainline. Your access depends on the scenario itself, not the workspace.'
          )}
        </Text>
      </FlexBox>
    </Box>
  ),
});
